import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { FormRow } from '@repo/ui-components/form/FormRow';
import FormContainer from '@repo/ui-components/form/FormContainer';
import styles from '@repo/ui-components/styles';

const StyledFormContainer = styled(FormContainer)`
  ${FormRow} {
    margin-bottom: ${styles.spacing['spacing-lg']};
  }

  ${FormRow}:last-of-type {
    margin-bottom: unset;
  }
`;

const ValidationMessage = styled.div`
  display: flex;
  width: 100%;
  p {
    margin: ${styles.spacing['spacing-1xs']} 0;
  }
`;

function LeadCapture({
  handleForm,
  errors,
  name,
  email,
  postalCode,
  setName,
  setEmail,
  setPostalCode,
}) {
  return (
    <StyledFormContainer name="formLead" onSubmit={handleForm}>
      <FormRow invalid={errors.name}>
        <label htmlFor="name">
          Name{' '}
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </label>
        {errors?.name && (
          <ValidationMessage>
            <p>{errors.name}</p>
          </ValidationMessage>
        )}
      </FormRow>

      <FormRow invalid={errors.email}>
        <label htmlFor="email">
          Email Address{' '}
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </label>
        {errors?.email && (
          <ValidationMessage>
            <p>{errors.email}</p>
          </ValidationMessage>
        )}
      </FormRow>

      <FormRow invalid={errors.postalCode}>
        <label htmlFor="postalCode">
          Postal Code{' '}
          <input
            type="text"
            value={postalCode}
            onChange={e => setPostalCode(e.target.value)}
          />
        </label>
        {errors?.postalCode && (
          <ValidationMessage>
            <p>{errors.postalCode}</p>
          </ValidationMessage>
        )}
      </FormRow>

      <input type="submit" style={{ display: 'none' }} />
    </StyledFormContainer>
  );
}

LeadCapture.propTypes = {
  handleForm: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    postalCode: PropTypes.string,
  }),
  name: PropTypes.string,
  email: PropTypes.string,
  postalCode: PropTypes.string,
  setName: PropTypes.func.isRequired,
  setEmail: PropTypes.func.isRequired,
  setPostalCode: PropTypes.func.isRequired,
};

LeadCapture.defaultProps = {
  name: '',
  email: '',
  postalCode: '',
  errors: {},
};

export default LeadCapture;
